export const OOCYTE_DONATION = {
  id: 'oocyte_donation',
  label: 'Ovodonazione',
};

export const SPERM_DONATION = {
  id: 'sperm_donation',
  label: 'Donazione di gameti maschili',
};

export const EMBRYO_DONATION = {
  id: 'embryo_donation',
  label: 'Embriodonazione',
};

export const NONE = {
  id: 'none',
  label: 'No',
};

export const HOMOLOGOUS = {
  id: 'homologous',
  label: 'Omologa',
};
